import { render, staticRenderFns } from "./MyBundleCourse.vue?vue&type=template&id=6fb5844d&scoped=true&"
import script from "./MyBundleCourse.vue?vue&type=script&lang=js&"
export * from "./MyBundleCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5844d",
  null
  
)

export default component.exports